import { CelRequest, Facet, Result, PrekSchool, SCHOOL_TYPE, SchoolType } from "../interfaces"

function ucFirst(string) {
    // hack for now
    if (string && string.startsWith('cps')) {
        return string.replace('cps', 'CPS')
    }
    if (string && string.startsWith('lpPrograms')) {
        return string.replace('lpPrograms', 'LPPrograms')
    }
    if (string && string.startsWith('hscrPrograms')) {
        return string.replace('hscrPrograms', 'HSCRPrograms')
    }
    if (string && string.startsWith('ctePrograms')) {
        return string.replace('ctePrograms', 'CTEPrograms')
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lcFirst(text) {
    // hack for now
    if (text && text.startsWith('CPS')) {
        return text.replace('CPS', 'cps')
    }
    if (text && text.startsWith('LPPrograms')) {
        return text.replace('LPPrograms', 'lpPrograms')
    }
    if (text && text.startsWith('HSCRPrograms')) {
        return text.replace('HSCRPrograms', 'hscrPrograms')
    }
    if (text && text.startsWith('CTEPrograms')) {
        return text.replace('CTEPrograms', 'ctePrograms')
    }

    return text && text[0].toLowerCase() + text.slice(1) || text;
};

export function displayShortened(s) {
    if (s) {
        s = s.replace('/2023', '') // @TODO misses dates that end in year /23
        s = s.replace('Monday', 'Mon');
        s = s.replace('Tuesday', 'Tue');
        s = s.replace('Wednesday', 'Wed');
        s = s.replace('Thursday', 'Thu');
        s = s.replace('Friday', 'Fri');
        s = s.replace('Saturday', 'Sat');
        s = s.replace('Sunday', 'Sun');
    }
    return s;
}

export function getSchoolTypeFromId(schoolId) {
    return ('' + schoolId).startsWith('8') ? SCHOOL_TYPE.CEL : SCHOOL_TYPE.CPS;
    if (('' + schoolId).length === 6 && ('' + schoolId).startsWith('6')) return SCHOOL_TYPE.CPS;
    if (('' + schoolId).length === 9) return 'cel';
    return 'cel';
}

export function interleave([x, ...xs], ys = []) {
    return x === undefined
        ? ys                             // base: no x
        // @ts-ignore
        : [x, ...interleave(ys, xs)]  // inductive: some x

}

export function interleavePrek(schools) {
    return interleave(
        schools.filter(s => s.type == SCHOOL_TYPE.CEL),
        schools.filter(s => s.type == SCHOOL_TYPE.CPS)
    )
}

// This function currently mutates filters, which isn't great design. 
// @TODO decided on a better way to do this
export function addFilterCounts(filters, schools) {
    // clear filter counts first
    for (let filter of filters) {
        for (let term of filter.terms) {
            term.count = 0;
        }
    }

    for (let school of schools) {
        for (let facet in school._epi.facets) {
            let terms = school._epi.facets[facet];
            for (let term of terms) {
                let foundFilters = filters.filter(f => f.searchFields.includes(ucFirst(facet)));
                if (foundFilters.length == 0) {
                    continue;
                }
                if (foundFilters[0].terms.filter(t => t.term == term)[0]) {
                    foundFilters[0].terms.filter(t => t.term == term)[0].count++;
                }
            }
        }
    }
    return filters;
}

export function formatPhone(phone) {
    // don't be very aggerssive with this
    if (phone && /[0-9]{10}/.test(phone)) {
        const match = phone.match(/([0-9]{3})([0-9]{3})([0-9]{4})/);
        return `${match[1]}-${match[2]}-${match[3]}`
    }
    return phone;
}

// add in ucfirst version of propertie because epi forces things into camelcase
export function addOriginalCase(obj) {
    let newObj = { ...obj };
    for (let prop in obj) {
        const val = obj[prop];
        const ucProp = prop.charAt(0).toUpperCase() + prop.slice(1);
        if (Array.isArray(val)) {
            const newVal = val.map(v => v && typeof v === 'object' ?
                addOriginalCase(v) : // recurse
                v
            )
            newObj[ucProp] = newVal;
            continue;
        }
        const newVal = val && typeof val === 'object' ?
            addOriginalCase(val) : // recurse
            val;

        newObj[ucProp] = newVal;

    }
    return newObj;
}

export function getEsHs(school) {
    // this is an estimation, probably set it in the api
    return school._epi.facets.primaryCategoryFullName.includes('High School') ? 'hs' : 'es';
}

// add a percent sign to an incoming string if it is not empty, otherwise keep the empty string
export function percentLabel(string) {
    return (string && `${string}%`);
}

// take incoming text describing availability and return a string of classes to draw an icon
export type Availability = 'Available' | 'Limited' | 'Waitlist' | null;
export type AvailabilityColor = 'green' | 'yellow' | 'red' | null;

export function getAvailability(availability: string): Availability {
    const match = availability ? availability.toUpperCase() : ''; // availability should be set, but has been the point of a few bugs so double check it.
    if (match.includes('AVAILABLE')) return 'Available';
    if (match.includes('LIMITED')) return 'Limited';
    if (match.includes('WAITLIST')) return 'Waitlist';
    return null;
}
export function getAvailabilityColor(value: string): AvailabilityColor {
    switch (getAvailability(value)) {
        case 'Available':
            return 'green';
        case 'Limited':
            return 'yellow';
        case 'Waitlist':
            return 'red';
        default:
            return null;
    }
}

export function formatedSchools(schools: Result[]): PrekSchool[] {

    return schools.map((profile: Result): PrekSchool => {
        return {
            type: profile.schoolType == "Community Based" ? SCHOOL_TYPE.CEL as SchoolType : SCHOOL_TYPE.CPS as SchoolType,
            _epi: {
                ...profile,
                facets: {
                    id: ['' + profile.id],
                    ...profile.facets
                }
            }
        }
    })
}